@if (dates.length > 0) {
  <div class="mat-elevation-z8">
    <table mat-table class="stripped-table" [dataSource]="dDataSource">
      <!-- Field Column -->
      <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef> Field </th>
        <td mat-cell class="name-column" *matCellDef="let row"> {{row.field}} </td>
      </ng-container>
      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Value </th>
        <td mat-cell *matCellDef="let row"><span class="value-column">@if (row.isTarget) {
          <mat-icon class="target-icon">track_changes</mat-icon>
        } {{row.value}} </span></td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: dColumns;"></tr>
    </table>
  </div>
}
@if (dates.length <= 0) {
  <div>
    <i>There are no other dates for this disposition.</i>
  </div>
}
